import React from "react";

import {
  Container,
  Card,
  ContentGeral,
  CardGeral,
  Icon,
  Content,
} from "./styles";
import Header from "../../../components/Header";
import { useEffect } from "react";
import { useState } from "react";

import { api } from "../../../services/api";
import { mascaraCnpj } from "../../../services/utils";
import SideBarAdmin from "../../../components/SideBarAdmin";

import empresaIcon from "../../../assets/empresa_icon.png";
import empregoIcon from "../../../assets/emprego_icon.png";
import contratoIcon from "../../../assets/contrato_icon.png";
import alunoIcon from "../../../assets/aluno_icon.png";
import candidatoIcon from "../../../assets/candidate-icon.png";
import vagasIcon from "../../../assets/vagas-icon.png";
import { StyledEmpresa } from "../Empresas/styles";
import SpinnerLoading from "../../../components/SpinnerLoading";
import { Link } from "react-router-dom";

const Empresa = ({ empresa, changeStatus }) => {
  return (
    <StyledEmpresa>
      <section>
        <h3>{empresa.nome}</h3>
        <p>
          <strong>CNPJ: </strong>
          {mascaraCnpj(empresa.cnpj)}
        </p>
        <p>
          <strong>Contato: </strong>
          {empresa.nome_contato}
        </p>
        <p>
          <strong>E-mail: </strong>
          {empresa.email_contato}
        </p>
        <p>
          <strong>Telefone: </strong>
          {empresa.telefone_contato}
        </p>
      </section>
    </StyledEmpresa>
  );
};

const Vaga = ({ vaga, changeStatus }) => {
  return (
    <StyledEmpresa>
      <section>
        <h3>
          {vaga.tipo_vaga} - {vaga.cargo} - {vaga.qtd_vagas}{" "}
          {vaga.qtd_vagas > 1 ? "vagas" : "vaga"}
        </h3>
        <p>
          <strong>Empresa:</strong> {vaga.empresa}
        </p>
      </section>
    </StyledEmpresa>
  );
};

function Home() {
  const [loading, setLoading] = useState(true);

  const headerLinks = [{ label: "Sair", to: "/" }];

  const [estatisticas, setEstatisticas] = useState({
    qtdEmpresas: 0,
    qtdOportunidades: 0,
    qtdContratados: 0,
    qtdAlunosAtivos: 0,
    vagasAbertas: [],
    novasEmpresas: [],
  });

  useEffect(() => {
    const buscarEstatisticas = async () => {
      try {
        const retorno = await api.get("/admin/estatisticas");

        setEstatisticas(retorno.data);
      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    buscarEstatisticas();
  }, []);

  const ativar = (empresaId) => {
    try {
      api.post(`/empresas/${empresaId}/ativacao`);

      const [empresaAux] = estatisticas.novasEmpresas.filter(
        (v) => v.id === empresaId
      );

      empresaAux.status = 1;

      setEstatisticas({
        ...estatisticas,
        novasEmpresas: estatisticas.novasEmpresas.filter(
          (v) => v.id !== empresaId
        ),
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Container>
      <SideBarAdmin></SideBarAdmin>
      <Header links={headerLinks} theme="black" />
      {loading ? (
        <SpinnerLoading style={{ marginTop: 80 }} />
      ) : (
        <>
          <ContentGeral>
            <CardGeral>
              <Icon src={empresaIcon} />
              <h4>Empresas Parceiras</h4>
              <h1>{estatisticas.qtdEmpresas}</h1>
            </CardGeral>
            <CardGeral>
              <Icon src={empregoIcon} />
              <h4>Oportunidades</h4>
              <h1>{estatisticas.qtdOportunidades}</h1>
            </CardGeral>
            <CardGeral>
              <Icon src={vagasIcon} />
              <h4>Vagas</h4>
              <h1>{estatisticas.qtdVagas}</h1>
            </CardGeral>
            <CardGeral>
              <Icon src={alunoIcon} />
              <h4>Alunos Ativos</h4>
              <h1>{estatisticas.qtdAlunosAtivos}</h1>
            </CardGeral>
            <CardGeral>
              <Icon src={candidatoIcon} />
              <h4>Candidaturas</h4>
              <h1>{estatisticas.qtdCandidaturas}</h1>
            </CardGeral>
            <CardGeral>
              <Icon src={contratoIcon} />
              <h4>Alunos contratados</h4>
              <h1>{estatisticas.qtdContratados}</h1>
            </CardGeral>
          </ContentGeral>
          <Content>
            <hr />
            <Card style={{ marginBottom: 0 }}>
              <h1>Últimas Empresas Cadastradas</h1>
              {estatisticas.novasEmpresas.length === 0
                ? "Nenhuma nova empresa cadastrada."
                : estatisticas.novasEmpresas.map((e) => (
                    <Empresa
                      key={e.id}
                      empresa={e}
                      changeStatus={() => ativar(e.id)}
                    />
                  ))}
            </Card>
          </Content>
          <Content style={{ marginTop: 0 }}>
            <hr />
            <Card style={{ marginBottom: 0 }}>
              <h1>Últimas Vagas Abertas <Link to="/admin/vagas">Ver mais</Link></h1> 
              {estatisticas.vagasAbertas.length === 0
                ? "Por enquanto, nenhuma vaga aberta."
                : estatisticas.vagasAbertas.map((v) => (
                    <Vaga key={v.id} vaga={v} />
                  ))}
            </Card>
          </Content>
        </>
      )}
    </Container>
  );
}

export default Home;
